import { parentesco } from '@utils';
import {
  casoUniaoEstavel,
  certidaoGenitor,
  childs,
  commons,
  convivente,
  death,
  others,
  parents,
  spouses,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';
import { declaracaoVeracidade } from '../../utils/rulesByKey';

const { constants } = parentesco;

export const SaldoMATDocs = () => {
  const rules = {
    anexoCertidaoDeObito: dynamicRule('required'),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),

    anexoCertidaoCasamentoOuNascimento: dynamicRule('pais'),

    anexoCertidaoCasamento: dynamicRule('casamento'),

    anexoCertidaoNascimento: dynamicRule('nascimento'),

    anexoConvivente: dynamicRule('convivente'),
    anexoCasoUniaoEstavel: dynamicRule(),

    anexoCertidaoCasamentoGenitor: dynamicRule('enteado'),

    anexoOutros: dynamicRule(),
    ...declaracaoVeracidade,
  };

  const docs = {
    commons: [...death, ...commons],
    others: [...others],
    [constants.PAI]: [...parents],
    [constants.MAE]: [...parents],
    [constants.CONJUGE]: [...spouses],
    [constants.EX_CONJUGE]: [...spouses],
    [constants.FILHO]: [...childs],
    [constants.CONVIVENTE]: [...convivente, ...casoUniaoEstavel],
    [constants.ENTEADO]: [...childs, ...certidaoGenitor],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
